var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-semibold text-sm text-ayadi-900 bg-textGray-100 rounded-3xl px-4 py-2"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }